import updatePrice from './product/update-price';
import fillSelects from './product/selects';

export default {
  init() {
    console.log('produkt');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    updatePrice();
    fillSelects();
  }
};
